import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./filterModal.html";
import { FILTER_OPTIONS, NONE_OPTION } from '../utils/appConstants';
const {
  CONFIGURATION_NAME,
  DEVELOPER_NAME,
  TYPE,
  SUB_TYPE
} = FILTER_OPTIONS;
class FilterModal extends LightningElement {
  constructor() {
    super();
    this.searchConfigName = '';
    this.searchDeveloperName = '';
    this.searchCompType = '';
    this.searchFromDate = '';
    this.searchToDate = '';
    this.isexportbtndisabled = void 0;
    this.value = '';
    this.options = [];
    this.modifiedByOptions = [];
    this.tagsOptions = [];
    this.selectedTypes = [];
    this.selectedModifiedBy = [];
    this.selectedTags = [];
    this.modifiedByValue = 'Select';
    this.compTypeValue = 'Select';
    this.tagsValue = 'Select';
    this.selModifiedByValues = [];
    this.selCompTypeValues = [];
    this.selTagsValues = [];
    this.selPickType = '';
    this.selModifiedBy = [];
    this.selCompTypes = [];
    this.selTags = [];
    this.todaysDate = new Date().toISOString();
    this.invalidDateFormatMsg = 'Invalid date format';
    this.updatedExportbtnValue = isexportbtndisabled => {
      this.isexportbtndisabled = isexportbtndisabled;
    };
    this.compTypeOptions = options => {
      let tempOptions = [];
      for (let index = 0; index < options.length; index++) {
        if (options[index]) {
          tempOptions.push({
            label: options[index],
            value: options[index].split(/\s/).join('')
          });
        }
      }
      this.options = tempOptions;
    };
    this.showModifiedByUsers = options => {
      let tempOptions = [];
      for (let index = 0; index < options.length; index++) {
        if (options[index]) {
          tempOptions.push({
            label: options[index],
            value: options[index].split(/\s/).join('')
          });
        }
      }
      this.modifiedByOptions = tempOptions;
    };
    this.showTags = tagsOptions => {
      let tempTagsOptions = [];
      for (let index = 0; index < tagsOptions.length; index++) {
        if (tagsOptions[index]) {
          tempTagsOptions.push({
            label: tagsOptions[index],
            value: tagsOptions[index].split(/\s/).join('')
          });
        }
      }
      if (tempTagsOptions && tempTagsOptions.length === 0) {
        tempTagsOptions.push({
          label: NONE_OPTION,
          value: NONE_OPTION
        });
      }
      this.tagsOptions = tempTagsOptions;
    };
    this.closeFilterModalPopup = () => {
      const selectedEvent = new CustomEvent("closefiltermodal", {});
      this.dispatchEvent(selectedEvent);
    };
    this.handleClearButton = event => {
      if (event.currentTarget.value && event.currentTarget.value.length > 0) {
        const enableFilterIconEvent = new CustomEvent("enablefiltericon", {});
        this.dispatchEvent(enableFilterIconEvent);
      } else {
        const disableFilterIconEvent = new CustomEvent("disablefiltericon", {});
        this.dispatchEvent(disableFilterIconEvent);
      }
      if (event.currentTarget.placeholder === CONFIGURATION_NAME) {
        if (event.currentTarget.value && event.currentTarget.value.length > 0) {
          this.enableDisableClearButton('configurationNameButton', 'block');
        } else {
          this.enableDisableClearButton('configurationNameButton', 'none');
        }
      } else if (event.currentTarget.placeholder === DEVELOPER_NAME) {
        if (event.currentTarget.value && event.currentTarget.value.length > 0) {
          this.enableDisableClearButton('developerNameButton', 'block');
        } else {
          this.enableDisableClearButton('developerNameButton', 'none');
        }
      }
    };
    this.enableDisableClearButton = (confType, displayValue) => {
      if (this.template.querySelector(`button[data-my-id='${confType}']`)) {
        this.template.querySelector(`button[data-my-id='${confType}']`).style.display = `${displayValue}`;
      }
    };
    this.clearConfValue = () => {
      this.clearInputValue(CONFIGURATION_NAME);
    };
    this.clearDevNameValue = () => {
      this.clearInputValue(DEVELOPER_NAME);
    };
    this.clearCompTypeValue = () => {
      this.clearInputValue(TYPE);
    };
    this.clearCompSubTypeValue = () => {
      this.clearInputValue(SUB_TYPE);
    };
    this.clearInputValue = type => {
      switch (type) {
        case DEVELOPER_NAME:
          this.template.querySelector('input[data-my-id="developerName"]').value = null;
          this.enableDisableClearButton('developerNameButton', 'none');
          break;
        case TYPE:
          this.template.querySelector('input[data-my-id="compType"]').value = null;
          this.enableDisableClearButton('compTypeButton', 'none');
          break;
        default:
          this.template.querySelector('input[data-my-id="configurationName"]').value = null;
          this.enableDisableClearButton('configurationNameButton', 'none');
      }
      const disableFilterIconEvent = new CustomEvent("disablefiltericon", {});
      this.dispatchEvent(disableFilterIconEvent);
    };
    this.applyFilter = () => {
      const localThisState = this;
      const configurationName = localThisState.template.querySelector('input[data-my-id="configurationName"]').value;
      let compType = localThisState.template.querySelector('my-picklist[data-my-id="compType"]').selectedValues;
      let modifiedBy = localThisState.template.querySelector('my-picklist[data-my-id="modifiedBy"]').selectedValues;
      let tags = localThisState.template.querySelector('my-picklist[data-my-id="tags"]').selectedValues;
      if (compType != null && compType.length > 0) {
        compType = localThisState.formattedSelTypes(localThisState.selectedTypes);
      } else if (localThisState.compTypeValue != null) {
        compType = localThisState.compTypeValue === 'Select' ? [] : localThisState.compTypeValue;
      }
      if (modifiedBy != null && modifiedBy.length > 0) {
        modifiedBy = localThisState.formattedSelTypes(localThisState.selectedModifiedBy);
      } else if (localThisState.modifiedByValue != null) {
        modifiedBy = localThisState.modifiedByValue === 'Select' ? [] : localThisState.modifiedByValue;
      }
      if (tags != null && tags.length > 0) {
        tags = localThisState.formattedSelTypes(localThisState.selectedTags);
      } else if (localThisState.tagsValue != null) {
        tags = localThisState.tagsValue === 'Select' ? [] : localThisState.tagsValue;
      }
      const fromDate = localThisState.template.querySelector('lightning-input[data-my-id="fromDate"]').value;
      const toDate = localThisState.template.querySelector('lightning-input[data-my-id="toDate"]').value;
      const filterCriteria = {
        configurationName,
        compType,
        modifiedBy,
        tags,
        fromDate,
        toDate
      };
      const filterCriteriaEvent = new CustomEvent("applyfilter", {
        detail: filterCriteria
      });
      localThisState.dispatchEvent(filterCriteriaEvent);
    };
    this.handleValidateDatePicker = () => {
      const localThisState = this;
      const fromDate = localThisState.template.querySelector('lightning-input[data-my-id="fromDate"]').value;
      const toDate = localThisState.template.querySelector('lightning-input[data-my-id="toDate"]').value;
      const isValidFromDate = localThisState.template.querySelector('lightning-input[data-my-id="fromDate"]').reportValidity();
      const isValidToDate = localThisState.template.querySelector('lightning-input[data-my-id="toDate"]').reportValidity();
      const isFromDateEmpty = fromDate ? fromDate : null;
      const isToDateEmpty = toDate ? toDate : null;
      if (!isValidFromDate || !isValidToDate) {
        localThisState.template.querySelector('button[data-my-id="filterApplyButton"]').disabled = true;
      } else if (!isFromDateEmpty && isToDateEmpty) {
        localThisState.template.querySelector('button[data-my-id="filterApplyButton"]').disabled = true;
      } else if (isFromDateEmpty && !isToDateEmpty) {
        localThisState.template.querySelector('button[data-my-id="filterApplyButton"]').disabled = true;
      } else {
        localThisState.template.querySelector('button[data-my-id="filterApplyButton"]').disabled = false;
      }
    };
    this.updatedSelectionTypes = (selectedTypes, selectedPicklistType) => {
      if (selectedPicklistType === 'compType') {
        this.selectedTypes = selectedTypes;
      }
      if (selectedPicklistType === 'modifiedBy') {
        this.selectedModifiedBy = selectedTypes;
      }
      if (selectedPicklistType === 'tags') {
        this.selectedTags = selectedTypes;
      }
    };
    this.updateSelTypeValue = (data, value, selValue) => {
      let selectedCompType;
      const compTypePicklistRef = this.template.querySelector('my-picklist[data-my-id="compType"]');
      if (compTypePicklistRef) {
        selectedCompType = compTypePicklistRef.retainTypeSelection(data, value, selValue);
        this.selCompTypeValues = compTypePicklistRef.getSelectedValues();
      }
      this.compTypeValue = selectedCompType;
    };
    this.updateSelModifiedByValue = (data, value, selValue) => {
      let selectedModifiedBy;
      const modifiedByPicklistRef = this.template.querySelector('my-picklist[data-my-id="modifiedBy"]');
      if (modifiedByPicklistRef) {
        selectedModifiedBy = modifiedByPicklistRef.retainTypeSelection(data, value, selValue);
        this.selModifiedByValues = modifiedByPicklistRef.getSelectedValues();
      }
      this.modifiedByValue = selectedModifiedBy;
    };
    this.updateSelTagsValue = (data, value, selValue) => {
      let selectedTags;
      const tagsPicklistRef = this.template.querySelector('my-picklist[data-my-id="tags"]');
      if (tagsPicklistRef) {
        selectedTags = tagsPicklistRef.retainTypeSelection(data, value, selValue);
        this.selTagsValues = tagsPicklistRef.getSelectedValues();
      }
      this.tagsValue = selectedTags;
    };
    this.handleUpdatedPicklistValue = () => {
      const configName = this.template.querySelector('input[data-my-id="configurationName"]');
      const developerName = this.template.querySelector('input[data-my-id="developerName"]');
      this.modifiedByValue = 'Select';
      this.selModifiedByValues = [];
      if (configName && configName.value) {
        this.searchConfigName = configName.value;
      }
      if (developerName && developerName.value) {
        this.searchDeveloperName = developerName.value;
      }
    };
    this.handleUpdatedCompTypePicklistValue = () => {
      this.compTypeValue = 'Select';
      this.selCompTypeValues = [];
    };
    this.handleUpdatedTagsPicklistValue = () => {
      this.tagValue = 'Select';
      this.tagsValue = 'Select';
      this.selTagsValues = [];
    };
    this.handleValueChange = event => {
      const localThisState = this;
      const selectedTypes = event && event.detail ? JSON.stringify(event.detail) : localThisState.selectedTypes;
      let selectedPicklist;
      if (localThisState.template.querySelector('my-picklist[data-my-id="modifiedBy"]') !== null && localThisState.template.querySelector('my-picklist[data-my-id="modifiedBy"]').value.length > 0 && event.currentTarget.name === 'modifiedBy') {
        selectedPicklist = 'modifiedBy';
        localThisState.selectedModifiedBy = selectedTypes;
      }
      if (localThisState.template.querySelector('my-picklist[data-my-id="compType"]') !== null && localThisState.template.querySelector('my-picklist[data-my-id="compType"]').value.length > 0 && event.currentTarget.name === 'compType') {
        selectedPicklist = 'compType';
        localThisState.selectedTypes = selectedTypes;
      }
      if (localThisState.template.querySelector('my-picklist[data-my-id="tags"]') !== null && localThisState.template.querySelector('my-picklist[data-my-id="tags"]').value.length > 0 && event.currentTarget.name === 'tags') {
        selectedPicklist = 'tags';
        localThisState.selectedTags = selectedTypes;
      }
      this.selPickType = selectedPicklist;
      const selectedOptionTypeEvent = new CustomEvent("selectedoptiontypes", {
        detail: {
          selectedTypes: selectedTypes,
          selectedPicklist: selectedPicklist
        }
      });
      localThisState.dispatchEvent(selectedOptionTypeEvent);
    };
    this.formattedSelTypes = types => {
      let tempSelectedTypes = [];
      if (types && types.length > 0) {
        const formatTypes = JSON.parse(types);
        for (let index = 0; index < formatTypes.length; index++) {
          const {
            name
          } = formatTypes[index];
          tempSelectedTypes.push(name);
        }
      }
      return tempSelectedTypes;
    };
    this.enableFilterIconOnTypeSel = event => {
      const selectedTypes = event.detail;
      const selectedPickType = this.selPickType;
      if (selectedPickType === 'modifiedBy') {
        if (!this.selModifiedBy.includes(selectedTypes)) {
          this.selModifiedBy.push(selectedTypes);
        }
      }
      if (selectedPickType === 'compType') {
        if (!this.selCompTypes.includes(selectedTypes)) {
          this.selCompTypes.push(selectedTypes);
        }
      }
      if (selectedPickType === 'tags') {
        if (!this.selTags.includes(selectedTypes)) {
          this.selTags.push(selectedTypes);
        }
      }
      if (selectedTypes && selectedTypes.length > 0) {
        const enableFilterIconEvent = new CustomEvent("enablefiltericon", {});
        this.dispatchEvent(enableFilterIconEvent);
      } else {
        const disableFilterIconEvent = new CustomEvent("disablefiltericon", {});
        this.dispatchEvent(disableFilterIconEvent);
      }
    };
    this.enableFilterIconOnDateChange = event => {
      if (event && event.detail) {
        const {
          detail: {
            value
          }
        } = event;
        if (value) {
          const enableFilterIconEvent = new CustomEvent("enablefiltericon", {});
          this.dispatchEvent(enableFilterIconEvent);
        }
      }
    };
    this.handleClearFilter = () => {
      const localThisState = this;
      localThisState.template.querySelector('input[data-my-id="configurationName"]').value = '';
      const modifiedBy = localThisState.template.querySelector('my-picklist[data-my-id="modifiedBy"]').value;
      const compType = localThisState.template.querySelector('my-picklist[data-my-id="compType"]').value;
      const tags = localThisState.template.querySelector('my-picklist[data-my-id="tags"]').value;
      localThisState.template.querySelector('lightning-input[data-my-id="fromDate"]').value = '';
      localThisState.template.querySelector('lightning-input[data-my-id="toDate"]').value = '';
      const modifiedByPicklist = localThisState.template.querySelector('my-picklist[data-my-id="modifiedBy"]');
      const compTypePicklist = localThisState.template.querySelector('my-picklist[data-my-id="compType"]');
      const tagsPicklist = localThisState.template.querySelector('my-picklist[data-my-id="tags"]');
      if (modifiedBy != null && modifiedBy.length > 0 && modifiedByPicklist) {
        modifiedByPicklist.clearOptions(localThisState.modifiedByOptions, modifiedBy);
      }
      if (compType != null && compType.length > 0 && compTypePicklist) {
        compTypePicklist.clearOptions(localThisState.options, compType);
      }
      if (tags != null && tags.length > 0 && tagsPicklist) {
        tagsPicklist.clearOptions(localThisState.tagsOptions, tags);
      }
      localThisState.enableDisableClearButton('configurationNameButton', 'none');
      localThisState.selectedTypes = [];
      localThisState.selectedModifiedBy = [];
      localThisState.selectedTags = [];
      localThisState.selModifiedBy = [];
      localThisState.selCompTypes = [];
      localThisState.selTags = [];
      localThisState.modifiedByValue = 'Select';
      localThisState.compTypeValue = 'Select';
      localThisState.tagsValue = 'Select';
      localThisState.template.querySelector('button[data-my-id="filterApplyButton"]').disabled = false;
      const clearFilterValuesEvent = new CustomEvent("clearfiltervalues", {});
      localThisState.dispatchEvent(clearFilterValuesEvent);
      window.setTimeout(() => {
        localThisState.template.querySelectorAll('lightning-input').forEach(element => {
          element.reportValidity();
        });
      }, 10);
    };
    if (this.template.querySelector('button[data-my-id="configurationNameButton"]')) {
      this.template.querySelector('button[data-my-id="configurationNameButton"]').style.display = 'none';
    }
  }
  renderedCallback() {
    if (this.isexportbtndisabled && this.template.querySelector('div[data-my-id="filterModal"]')) {
      this.template.querySelector('div[data-my-id="filterModal"]').classList.add('filter-upload__align');
    }
  }
  handleChange(event) {
    this.value = event.detail.value;
  }
}
_registerDecorators(FilterModal, {
  publicProps: {
    searchConfigName: {
      config: 0
    },
    searchDeveloperName: {
      config: 0
    },
    searchCompType: {
      config: 0
    },
    searchFromDate: {
      config: 0
    },
    searchToDate: {
      config: 0
    },
    isexportbtndisabled: {
      config: 0
    },
    selectedTypes: {
      config: 0
    },
    selectedModifiedBy: {
      config: 0
    },
    selectedTags: {
      config: 0
    },
    compTypeOptions: {
      config: 0
    },
    showModifiedByUsers: {
      config: 0
    },
    showTags: {
      config: 0
    },
    enableDisableClearButton: {
      config: 0
    },
    updatedSelectionTypes: {
      config: 0
    },
    updateSelTypeValue: {
      config: 0
    },
    updateSelModifiedByValue: {
      config: 0
    },
    updateSelTagsValue: {
      config: 0
    }
  },
  fields: ["value", "options", "modifiedByOptions", "tagsOptions", "modifiedByValue", "compTypeValue", "tagsValue", "selModifiedByValues", "selCompTypeValues", "selTagsValues", "selPickType", "selModifiedBy", "selCompTypes", "selTags", "todaysDate", "invalidDateFormatMsg", "updatedExportbtnValue", "closeFilterModalPopup", "handleClearButton", "clearConfValue", "clearDevNameValue", "clearCompTypeValue", "clearCompSubTypeValue", "clearInputValue", "applyFilter", "handleValidateDatePicker", "handleUpdatedPicklistValue", "handleUpdatedCompTypePicklistValue", "handleUpdatedTagsPicklistValue", "handleValueChange", "formattedSelTypes", "enableFilterIconOnTypeSel", "enableFilterIconOnDateChange", "handleClearFilter"]
});
export default _registerComponent(FilterModal, {
  tmpl: _tmpl
});